import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';
import { useOpportunityStatusesStore } from '@/store/opportunityStatuses';

export const opportunitiesOptions = {
    searchClientsAndLeads: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads(query);
    return store.clients_leads;
  },
  searchUsers: async (query: string | Record<string, any> = '') => {
    const store = useUsersStore();
    await store.searchUsers(query);
    return store.users_result;
  },
  searchOpportunityStatuses: async (query: string | Record<string, any> = '') => {
    const store = useOpportunityStatusesStore();
    await store.searchOpportunityStatuses(query);
    return store.opportunityStatuses_result;
  },
};
